// extracted by mini-css-extract-plugin
export var entry1 = "featured-grid-module--entry1--62baf";
export var entry2 = "featured-grid-module--entry2--532c3";
export var entry3 = "featured-grid-module--entry3--0bfab";
export var wrapper = "featured-grid-module--wrapper--90b81";